import { graphql } from "babel-plugin-relay/macro";

export const QUERY = graphql`
	query multipleChoiceAnswersDropdowns_Query($elementId: ID!) {
		LearnV2 {
			GetLearnElement(elementId: $elementId) {
				id
				answerOptions {
					answer
				}
				answeringType
			}
		}
	}
`;

export const SUBMIT_MUTATION = graphql`
	mutation multipleChoiceAnswersDropdowns_SubmitMultipleChoiceElementMutation(
		$input: AddNewMultipleChoiceSubmissionInput!
	) {
		LearnV2 {
			addNewMultipleChoiceSubmission(input: $input) {
				contentSubmission {
					definition {
						... on ActiveELearningContentSubmissionDefinition {
							progress {
								percentage
							}
						}
					}
					id
					...RightFrameContentSubmissionComponent_ContentSubmissionFragment
				}
			}
		}
	}
`;
